import { CustomPostFields } from '@tribeplatform/gql-client/graphql/post'

import { StaticField, View } from '../../Views/types'

interface GenerateActiveFieldIds {
  staticFields: StaticField[]
  style: View['style']
}
const getActiveFields = ({
  staticFields,
  style,
}: GenerateActiveFieldIds): StaticField[] => {
  let output: StaticField[] = []
  staticFields
    .filter(
      ({ enabled, styles, isStatic }) =>
        enabled && isStatic && !(styles && !styles.includes(style)),
    )
    .forEach(field => {
      output = [...output, field]

      if (field?.fields) {
        output = [
          ...output,
          ...getActiveFields({ staticFields: field.fields, style }),
        ]
      }
    })

  return output
}

interface Props {
  staticFields: StaticField[]
  style: View['style']
}
export const generateGqlFields = ({
  staticFields,
  style,
}: Props): CustomPostFields => {
  const activeFields = getActiveFields({ staticFields, style })

  const postFields = activeFields.reduce((prev, field) => {
    switch (field.id) {
      case 'tags':
      case 'listTags':
        return { ...prev, tags: 'all' } as CustomPostFields
      case 'replyList':
        return {
          ...prev,
          attachments: 'basic',
          authMemberProps: 'all',
          replies: {
            fields: {
              authMemberProps: 'all',
              embeds: 'basic',
              mentions: 'basic',
              attachments: 'basic',
              owner: {
                member: { profilePicture: 'basic', badges: 'all' },
              },
              reactions: { fields: 'all', variables: { limit: 10 } },
            },
            variables: {
              limit: 2,
              reverse: true,
            },
          },
        } as CustomPostFields
      case 'listAvatar':
        return {
          ...prev,
          owner: {
            member: { profilePicture: 'basic', badges: 'all' },
          },
        } as CustomPostFields
      case 'galleryMemberInfo': {
        let postFields: CustomPostFields = {
          ...prev,
          owner: {
            member: { profilePicture: 'basic', badges: 'all' },
          },
        }

        if (field.settings?.showSpaceName) {
          postFields = {
            ...postFields,
            space: 'basic',
          }
        }

        return postFields
      }
      case 'cardPostInfoBar':
        return {
          ...prev,
          reactions: { fields: 'all', variables: { limit: 10 } },
        } as CustomPostFields
      case 'cardMemberInfo': {
        let postFields: CustomPostFields = {
          ...prev,
          owner: {
            member: { profilePicture: 'basic', badges: 'all' },
          },
        }

        if (field.settings?.showPostOptions) {
          postFields = {
            ...postFields,
            authMemberProps: 'all',
          }
        }

        if (field.settings?.showSpaceName) {
          postFields = {
            ...postFields,
            space: 'basic',
          }
        }

        return postFields
      }
      case 'reactButton':
        return {
          ...prev,
          authMemberProps: 'all',
          reactions: { fields: 'basic', variables: { limit: 10 } },
        } as CustomPostFields

      case 'actionBar':
        return {
          ...prev,
          authMemberProps: 'all',
        } as CustomPostFields
      case 'postInfoBar':
        return {
          ...prev,
          authMemberProps: 'all',
          space: 'basic',
        } as CustomPostFields
      default:
        return prev
    }
  }, {} as CustomPostFields)

  return postFields
}
